module.exports = __webpack_public_path__ + "static/media/sidebar_voting_blue.1e6a570e.svg";